import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { AppConfig } from "../../../../configs/app";
import { CommonService } from "../../../../services/common.service";
import { CartService } from "../../../../services/cart.service";
import { ReservationService } from "../../../../services/reservation.service";
import { FormatterService } from "../../../../services/formatter.service";

declare var Cleave: any;

@Component({
  selector: "page-reserve-insurance-index",
  templateUrl: "./index.component.html",
})
export class PageReserveInsuranceIndexComponent implements OnInit {
  public formGroup: FormGroup;
  public fgZurich: FormGroup;
  public postData: any;
  public cartData: any;
  public totalPeople: any;
  public listUser: any = [];
  public insuranceBirthday: any = {};
  public postForm: any;
  public userList: any;
  public insuranceData = {
    formData: {},
    insurancePrice: 0,
    // insurancePrice: 500,
    insuranceNumber: 0,
    useInsurance: false,
    // zurich
    zurich: {
      formData: {},
      insurancePrice: 0,
      useInsurance: false,
      isReadZurichTermsStatus: 0,
      useZurichStatus: 0,
    },
  };
  public insurancePassengerData1: any;

  public useInsuranceStatus: number = -1;
  public useZurich = -1;
  public isReadZurichTerms = -1;

  public calcInsuranceDate = {
    startDate: "",
    endDate: "",
  };

  public chubbInsuranceHidden = false;
  public zurichInsuranceHidden = false;
  public zurichInsurancePrice = 0;

  public $: any;
  public moment: any;
  public _: any;

  /* CUSTOM VALIDATOR */
  public myValidator: any = {};

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  /* BUS SETTINGS */
  public busSettings: any = {};

  constructor(
    public formBuilder: FormBuilder,
    public appConfig: AppConfig,
    public commonService: CommonService,
    public cartService: CartService,
    public reservationService: ReservationService,
    public formatterService: FormatterService
  ) {
    let self = this;
    this.$ = this.commonService.getJQuery();
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();

    /* CUSTOM VALIDATOR */
    this.myValidator.matchAge = function (index: number, inputName: string) {
      return function (control: AbstractControl): any {
        let value = control.value.toString();
        value = value.replace(/[/]/g, "");
        if (value.length < 8) {
          return { matchAge: true };
        }

        if (self.insurancePassengerData1) {
          let age = self
            .moment()
            .diff(
              self.moment(control.value, "YYYYMMDD").format("YYYY-MM-DD"),
              "years"
            );
          if (age != self.insurancePassengerData1[index].age) {
            return { matchAge: true };
          }
        }

        return null;
      };
    };
    this.myValidator.isNumeric = (control: AbstractControl): any => {
      if (
        control.value &&
        control.value != "" &&
        !self.commonService.isNumeric(control.value)
      ) {
        return { isNumeric: true };
      }
      return null;
    };
  }

  async ngOnInit() {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    /* GET BUS SETTINGS */
    this.busSettings = this.commonService.getData(
      this.commonService.appConfig.site.settingSessionName
    );

    this.userList = await this.reservationService.getPassengerData();

    this.postData = this.reservationService.getReservationData();

    /* CHECK IF HAS DATA */
    if (this._.isEmpty(this.postData) || this._.isEmpty(this.userList)) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pagePlanList
      );
    }

    let insurancePassengerData =
      this.reservationService.getInsurancePassengerData1();

    /* HIDDEN CHUBB CHECKS */
    this.useInsuranceStatus = 0;
    if (this.busSettings.insurance.chubb) {
      try {
        // [F-13] [] → {} に修正。文字列キー("dpt_ymd0"等)で値を格納するため連想配列（オブジェクト）が正しい。
        //   修正前: let requestData = [] — Arrayに文字列キーを設定しても動作するが、
        //   Array.length は 0 のまま、JSON.stringify() では文字列キーが無視される、
        //   TypeScriptの型チェックが効かない等の問題がある。
        //   Angular HttpClient の params も内部で Object.keys() を使うため現状動作するが、
        //   将来の Angular バージョンアップで挙動が変わるリスクがある。
        let requestData: any = {};
        for (let planNum = 0; planNum < this.userList.length; planNum++) {
          requestData["dpt_ymd" + planNum] =
            this.userList[planNum]["primary"]["dpt_ymd"];
          requestData["plan_code" + planNum] =
            this.userList[planNum]["primary"]["planCode"];
        }
        for (let i = 0; i < insurancePassengerData.length; i++) {
          requestData["age" + i] = insurancePassengerData[i]["age"];
        }

        let params = {
          url: this.appConfig.busAPIBaseURL + "reserve/getCubbPrice",
          options: {
            headers: this.commonService.getHTTPBusHeader(),
            params: requestData,
          },
        };
        let returnedData = await this.commonService.sendHTTPGet(params);

        if (
          returnedData.status == "success" &&
          !this._.isEmpty(returnedData.data.insurance_token)
        ) {
          this.reservationService.saveInsuranceToken(
            returnedData.data.insurance_token
          );
        }

          // [CR-FRONT-05 #1] 本番環境限定if文を削除（全環境で動作するよう変更済み）
          // [CR-FRONT-06] _.isEmpty(数値) は常にtrueを返すため判定として機能しない
          //   lodash仕様: _.isEmpty(500) → true, _.isEmpty(0) → true
          //   修正: 同ファイル内getCubbPrice()（395行目）と同じパターンに統一
          let chubb_price = 0;
          if (
            returnedData.status == "success" &&
            returnedData.data.price != null
          ) {
            chubb_price = returnedData.data.price;
          } else {
            chubb_price = 0;
          }
          if (chubb_price == 0) {
            chubb_price = 0;
            this.chubbInsuranceHidden = true;
            this.appConfig.reservation.insurancePrice = chubb_price;
          } else {
            this.chubbInsuranceHidden =
              Boolean(this.postData.chubbInsuranceHidden) ||
              this.reservationService.checkChuBbMaxAge(this.postData);
            // this.useInsuranceStatus = 0;
            if (this.chubbInsuranceHidden) {
              this.useInsuranceStatus = 0;
            } else {
              // await this.getCubbPrice();
            }
          }
        // }
      } catch (err) {
        this.chubbInsuranceHidden = true;
        this.appConfig.reservation.insurancePrice = 0;
      }
    } else {
      this.chubbInsuranceHidden = true;
    }

    this.insurancePassengerData1 =
      this.reservationService.getInsurancePassengerData1();

    this.listUser = this.userList[0].list;

    this.totalPeople = this.userList[0].list.length;

    this.cartData = this.cartService.getCartData();
    let serchData: any = this.cartService.getSerchData();

    /* HIDDEN ZURICH CHECKS */
    this.zurichInsuranceHidden = this.reservationService.isNeedHideZurich(
      this.postData["1_dpt_ymd"],
      this.postData["c_birthday"],
      this.cartData
    );
    if (this.zurichInsuranceHidden) {
      this.useZurich = 0;
      // this.isReadZurichTerms = 0;
    }

    let totalCartPrice = 0;
    this.zurichInsurancePrice = 0;
    for (const cartPrice of this.cartData) {
      totalCartPrice += cartPrice.totalPrice;
      this.zurichInsurancePrice +=
        this.reservationService.calcZurichInsurancePrice(cartPrice.totalPrice);
    }

    // CALCULATION HOKEN DAY
    if (this.cartData.length == 1) {
      this.calcInsuranceDate.startDate = this.postData["1_dpt_ymd"];
      this.calcInsuranceDate.endDate = this.moment(
        this.postData["1_dpt_ymd"],
        "YYYYMMDD"
      )
        .add(1, "d")
        .format("YYYYMMDD");
    } else {
      this.calcInsuranceDate.startDate = this.postData["1_dpt_ymd"];
      this.calcInsuranceDate.endDate = this.moment(
        this.postData["2_dpt_ymd"],
        "YYYYMMDD"
      )
        .add(1, "d")
        .format("YYYYMMDD");
    }

    /* INITIALIZE FORM DATA */
    this.initFormGroup();

    /* EXECUTE INLINE JAVASCRIPT */
    this.inlineJS();

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }

  /* INITIALIZE FORM DATA */
  initFormGroup() {
    /* CHECK SAVED DATA */
    let insuranceData: any = this.reservationService.getInsuranceData();
    if (insuranceData) {
      this.useInsuranceStatus = insuranceData.useInsurance ? 1 : 0;
      this.useZurich =
        insuranceData.zurich && insuranceData.zurich.useZurichStatus ? 1 : 0;
      this.isReadZurichTerms = insuranceData.zurich
        ? insuranceData.zurich.isReadZurichTermsStatus
        : 0;
    }

    let formData = {};
    let birthday = this.postData["c_birthday"];
    for (let i = 0; i < this.insurancePassengerData1.length; i++) {
      /* REPRESENTATIVE */
      if (
        i === 0 &&
        this.postData.representationType_plan1 == 1 &&
        (!this.postData.hasOwnProperty("representationType_plan2") ||
          this.postData.representationType_plan2 == 1)
      ) {
        formData[`birthday_${i}`] = [
          insuranceData &&
          insuranceData.formData &&
          insuranceData.formData[`birthday_${i}`]
            ? insuranceData.formData[`birthday_${i}`]
            : birthday,
          [Validators.required, this.myValidator.matchAge(i, `birthday_${i}`)],
        ];
      } else {
        formData[`birthday_${i}`] = [
          insuranceData &&
          insuranceData.formData &&
          insuranceData.formData[`birthday_${i}`]
            ? insuranceData.formData[`birthday_${i}`]
            : "",
          [Validators.required, this.myValidator.matchAge(i, `birthday_${i}`)],
        ];
      }
    }

    this.formGroup = this.formBuilder.group(formData);
    this.fgZurich = this.formBuilder.group({
      zipcode: [
        insuranceData &&
        insuranceData.zurich &&
        insuranceData.zurich.formData[`zipcode`]
          ? insuranceData.zurich.formData[`zipcode`]
          : "",
        [
          Validators.required,
          this.myValidator.isNumeric,
          Validators.minLength(7),
          Validators.maxLength(7),
        ],
      ], // Validators.pattern(/^\d{7}$/)
      prefecture: [
        insuranceData &&
        insuranceData.zurich &&
        insuranceData.zurich.formData[`prefecture`]
          ? insuranceData.zurich.formData[`prefecture`]
          : "",
        Validators.required,
      ],
      city: [
        insuranceData &&
        insuranceData.zurich &&
        insuranceData.zurich.formData[`city`]
          ? insuranceData.zurich.formData[`city`]
          : "",
        Validators.required,
      ],
      street: [
        insuranceData &&
        insuranceData.zurich &&
        insuranceData.zurich.formData[`street`]
          ? insuranceData.zurich.formData[`street`]
          : "",
        [Validators.required],
      ],
      apartment: [
        insuranceData &&
        insuranceData.zurich &&
        insuranceData.zurich.formData[`apartment`]
          ? insuranceData.zurich.formData[`apartment`]
          : "",
      ],
    });

    this.tempData.formSubmitted = false;
  }

  checkBirthdayInputs(event: any, inputName: string) {
    this.formGroup.controls[inputName].setValue(event.target.value);
  }

  async searchAddressByZipCode() {
    if (this.fz.zipcode.value && this.fz.zipcode.value.length >= 7) {
      this.tempData.zipcodeSearching = true;
      if (this.tempData.zipcodeSearchText === this.fz.zipcode.value) {
        return;
      }
      this.tempData.zipcodeSearchText = this.fz.zipcode.value;
      let zipcodeData = await this.reservationService.searchAddressByZipCode({
        zipcode: this.fz.zipcode.value,
      });

      if (!this._.isEmpty(zipcodeData)) {
        zipcodeData = zipcodeData[0];
        this.fz.prefecture.setValue(zipcodeData.address1);
        this.fz.city.setValue(zipcodeData.address2);
        this.fz.street.setValue(zipcodeData.address3);
      }
    } else {
      this.fz.prefecture.setValue("");
      this.fz.city.setValue("");
      this.fz.street.setValue("");
    }
    delete this.tempData.zipcodeSearching;
    delete this.tempData.zipcodeSearchText;
  }

  async getCubbPrice() {
    // [F-13] [] → {} に修正。詳細は ngOnInit 内の同パターン修正コメント参照。
    let requestData: any = {};

    // requestData['requestData'] = '';
    for (let planNum = 0; planNum < this.userList.length; planNum++) {
      requestData["dpt_ymd" + planNum] =
        this.userList[planNum]["primary"]["dpt_ymd"];
      requestData["plan_code" + planNum] =
        this.userList[planNum]["primary"]["planCode"];
    }
    for (let i = 0; i < this.listUser.length; i++) {
      requestData["age" + i] = this.insurancePassengerData1[i]["age"];
    }

    let params = {
      url: this.appConfig.busAPIBaseURL + "reserve/getCubbPrice",
      options: {
        headers: this.commonService.getHTTPBusHeader(),
        params: requestData,
      },
    };

    let returnedData = await this.commonService.sendHTTPGet(params);
    let chubb_price = 0;
    if (returnedData.status == "success") {
      let returnData = returnedData.data;
      chubb_price = returnData.price;
      this.appConfig.reservation.insurancePrice = chubb_price;
      return false;
    } else {
      chubb_price = 0;
      this.chubbInsuranceHidden = true;
      this.appConfig.reservation.insurancePrice = chubb_price;
      return true;
    }
  }

  changeInputValue(event: any, inputName: any) {
    this.fz[inputName].setValue(event.target.value);
  }

  get fz() {
    return this.fgZurich.controls;
  }

  onSubmit() {
    this.tempData.formSubmitted = true;

    /* FORM ZEN TO HAN */
    this.commonService.convertFormInputZenToHan(this.formGroup);
    this.convertFormInputHanToZen(this.fgZurich, [
      "prefecture",
      "city",
      "street",
      "apartment",
    ]); // convert to double bytes
    this.formValidationInit();

    /* CHECK IF INSURANCE CHOSEN */
    if (this.useInsuranceStatus === -1) {
      this.$("html, body").animate(
        { scrollTop: this.$("#chooseInsuranceSection").offset().top - 8 },
        200
      );
      return false;
    } else if (
      this.useZurich === -1 ||
      (this.useZurich === 1 && this.isReadZurichTerms === -1)
    ) {
      this.$("html, body").animate(
        { scrollTop: this.$("#chooseZurichInsuranceSection").offset().top - 8 },
        200
      );
      return false;
    }

    /* CLEAR POSTPAY INFO */
    this.postData = this._.omit(this.postData, [
      "postpay_gmoID",
      "postpay_orderID",
    ]);

    if (this.useZurich === 1 && this.isReadZurichTerms === 1) {
      /* USE ZURICH */
      if (this.fgZurich.invalid) {
        return false;
      }
      this.insuranceData.zurich.useInsurance = true;
      this.insuranceData.zurich.insurancePrice = this.zurichInsurancePrice;

      this.postData.zr_use_insurance =
        this.appConfig.reservation.useInsuranceOn;
      this.postData.zr_zipcode = this.fgZurich.value.zipcode;
      this.postData.zr_prefecture = this.fgZurich.value.prefecture;
      this.postData.zr_city = this.fgZurich.value.city;
      this.postData.zr_street = this.fgZurich.value.street;
      this.postData.zr_apartment = this.fgZurich.value.apartment;

      this.insuranceData.zurich.formData = this.fgZurich.value;
    } else {
      delete this.postData.zr_use_insurance;
      delete this.postData.zr_zipcode;
      delete this.postData.zr_prefecture;
      delete this.postData.zr_city;
      delete this.postData.zr_street;
      delete this.postData.zr_apartment;

      this.insuranceData.zurich.formData = {};
      this.insuranceData.zurich.useInsurance = false;
    }
    this.insuranceData.zurich.useZurichStatus = this.useZurich;
    this.insuranceData.zurich.isReadZurichTermsStatus = this.isReadZurichTerms;

    if (this.useInsuranceStatus === 1) {
      /* USE INSURANCE */
      /* CHECK AGES */
      if (this.formGroup.invalid) {
        /* SCROLL TO THE FIRST ERROR FORM */
        if (this.$(".form-error:visible").length !== 0) {
          this.$("html, body").animate(
            {
              scrollTop:
                this.$(".form-error:visible").first().offset().top - 45,
            },
            200
          );
        }
        return false;
      }

      /* SET DATA */
      this.insuranceData.useInsurance = true;
      this.insuranceData.insuranceNumber = this.totalPeople;
      this.insuranceData.insurancePrice =
        this.totalPeople * this.appConfig.reservation.insurancePrice;

      this.postData["use_insurance"] =
        this.appConfig.reservation.useInsuranceOn;
      this.postData["number_insurance"] = this.totalPeople;

      /* DATE */
      for (let planNum = 0; planNum < this.userList.length; planNum++) {
        for (let i = 0; i < this.listUser.length; i++) {
          this.postData[`${planNum + 1}_p_birth_date_${i + 1}`] = this.formGroup
            .value[`birthday_${i}`]
            ? this.formGroup.value[`birthday_${i}`].replace(/[/]/g, "")
            : "";
        }
      }
      /* END */

      this.insuranceData.formData = this.formGroup.value;
    } else {
      /* NO INSURANCE */
      delete this.postData.use_insurance;
      delete this.postData.number_insurance;

      this.insuranceData.formData = {};
      this.insuranceData.useInsurance = false;
    }

    /* SAVE RESERVATION DATA */
    this.reservationService.saveReservationData(this.postData);
    /* SAVE INSURANCE DATA */
    this.reservationService.saveInsuranceData(this.insuranceData);

    /* GO TO NEXT PAGE */
    this.commonService.redirectToRoute(
      this.commonService.routePaths.pageReservePayment
    );
  }

  inlineJS() {
    let self = this;

    this.$(() => {
      self.formValidationInit();
    });

    self.$(function () {
      self.$(".tab").click(function () {
        self
          .$(this)
          .parent(".box-type2-inner")
          .find(".is--active")
          .removeClass("is--active");
        self.$(this).addClass("is--active");
        self
          .$(this)
          .parent(".box-type2-inner")
          .find(".is-show")
          .removeClass("is-show");
        const index = self.$(this).index();
        self
          .$(this)
          .parent(".box-type2-inner")
          .find(".panel")
          .eq(index)
          .addClass("is-show");
      });

      /* INIT INPUT ZEN TO HAN */
      self.commonService.zenToHan();
    });
  }

  formValidationInit() {
    this.$(".js-date").each(function () {
      new Cleave(this, {
        delimiter: "/",
        blocks: [4, 2, 2],
      });
    });

    if (this.$(".js-zipcode").length != 0) {
      new Cleave(".js-zipcode", {
        delimiter: "-",
        blocks: [7],
      });
    }
  }

  convertFormInputHanToZen(form: any, keys: string[]) {
    for (const key in form.value) {
      if (keys.includes(key) && form.controls[key]) {
        if (form.controls[key].value && form.controls[key].value != "") {
          form.controls[key].setValue(
            this.commonService.convertKana(form.controls[key].value, "ASKV")
          );
        }
      }
    }
  }
}
